export const formulaField = name => `[${name.replaceAll(']', ']]')}]`;
const literal = value => `"${value.replaceAll('"', '""')}"`;

export function starterFormula(fields) {
  const destination = fields.find(f => f.role === 'destination');
  if (!destination) return '';
  const args = [formulaField(destination.name)];
  fields.filter(f => f.role === 'parameter').forEach(f => args.push(literal(f.parameter), formulaField(f.name)));
  return `=BUILDURL(\n  ${args.join(',\n  ')}\n)`;
}

export function insertFormulaText(expression, start, end, insertion) {
  return { expression: expression.slice(0, start) + insertion + expression.slice(end), cursor: start + insertion.length };
}
